<template>
  <div class="countdown-container">
    <div class="countdown-circle">
      <svg class="progress-ring" width="44" height="44">
        <circle
          class="progress-ring__circle"
          :stroke="circleColor"
          stroke-width="2"
          fill="transparent"
          r="20"
          cx="22"
          cy="22"
          :stroke-dasharray="circumference + ' ' + circumference"
          :stroke-dashoffset="progress / 100 * circumference"
        />
      </svg>
      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    initializeControlTiming:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      circumference: 2 * Math.PI * 20,
    };
  },

  computed: {
    circleColor() {
      if (!this.initializeControlTiming) {
        return "transparent";
      }

      if (this.progress <= 25) return "#01C6D8";
      if (this.progress <= 50) return "#018FA6";
      if (this.progress <= 75) return "#014C75";
      
      return "#002136";
    },
  },
};
</script>

<style scoped>
.countdown-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.countdown-circle {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.5s ease;
  margin-top: 25px
}

/* svg inline deixa um espaço de baseline embaixo que desloca o centro
   visual do anel; block remove esse gap e garante a caixa exata de 44px */
.progress-ring {
  display: block;
}

.content {
    /* centraliza avatar E checkbox de seleção no anel de SLA
       (SVG 44px, centro 22,22) — flex centraliza o conteúdo do slot,
       o translate posiciona a caixa no centro do anel */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    z-index: 1;
}
.content input[type='checkbox']{
    margin: 0;
}

.progress-ring__circle {
  transition: stroke-dashoffset 0.5s linear;
  transform: rotate(-90deg);
  transform-origin: center;
}
</style>
